<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { http } from '@/services/http';

const feishuEnabled = ref(false);
const checkingFeishu = ref(true);
const configError = ref(false);
const feishuStartUrl = `/api/auth/feishu/start?${new URLSearchParams({ next: '/dashboard', origin: window.location.origin })}`;
onMounted(async () => {
  try {
    feishuEnabled.value = (await http.get<{ enabled: boolean }>('/api/auth/feishu/config')).enabled;
    if (feishuEnabled.value) {
      window.location.assign(feishuStartUrl);
    }
  } catch {
    feishuEnabled.value = false;
    configError.value = true;
  } finally {
    checkingFeishu.value = false;
  }
});
</script>

<template>
  <div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-sky-900">
    <div v-if="checkingFeishu || feishuEnabled" class="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-sm text-center">
      <div class="text-5xl mb-3">📦</div>
      <h1 class="text-2xl font-bold text-slate-800">备货系统</h1>
      <p class="text-sm text-slate-500 mt-2">{{ checkingFeishu ? '正在检查登录状态…' : '正在跳转到飞书登录…' }}</p>
      <a
        v-if="feishuEnabled"
        :href="feishuStartUrl"
        class="flex items-center justify-center gap-2 w-full mt-6 py-2.5 bg-[#3370ff] hover:bg-[#2860e1] text-white font-medium rounded-lg transition"
      >
        <span class="text-lg">◈</span> 使用飞书登录
      </a>
    </div>
    <div v-else class="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-sm text-center">
      <div class="text-center mb-6">
        <div class="text-5xl mb-2">📦</div>
        <h1 class="text-2xl font-bold text-slate-800">备货系统</h1>
        <p class="text-sm text-slate-500 mt-1">库存 · 销量 · 多仓 · 活动倍数</p>
      </div>
      <div class="text-sm text-rose-600 bg-rose-50 px-3 py-3 rounded-lg">
        {{ configError ? '登录服务暂时不可用，请刷新页面重试。' : '飞书登录尚未配置，请联系系统管理员。' }}
      </div>
    </div>
  </div>
</template>
